import React, { useEffect, useState } from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Outlet, useNavigate } from 'react-router-dom';
import useFetchRights from 'hooks/useFetchRightsGroups';
import Loadable from 'components/Loadable/Loadable';
import { lazy } from 'react';

const AuthLogin3 = Loadable(lazy(() => import('pages/authentication')));

export default function ProtectedRoutes({ restricted }) {
  const { inProgress } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const { hasFullAccess, loadingRights, isRestricted } = useFetchRights();
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    if (inProgress === 'none') {
      setIsInitialized(true);
    }
  }, [inProgress]);

  useEffect(() => {
    if (isInitialized && !loadingRights) {
      if (!isAuthenticated) {
        // If not authenticated, redirect to login
        navigate('/login');
      } else if (isAuthenticated && isRestricted && restricted) {
        // If the user is in the restricted group and the route is restricted, block access
        navigate('/premium');
      } else if (isAuthenticated && !hasFullAccess && !isRestricted) {
        // If the user is not in either the full access or restricted group, redirect to /premium
        navigate('/premium');
      } else if (isAuthenticated && hasFullAccess) {
        // Allow access to all routes for full access users
        const initialRedirectDone = sessionStorage.getItem('initialLoginRedirectDone');
        if (!initialRedirectDone) {
          navigate('/world-ranking'); // Redirect to a default page after successful login
          sessionStorage.setItem('initialLoginRedirectDone', 'true');
        }
      }
    }
  }, [isInitialized, isAuthenticated, hasFullAccess, isRestricted, restricted, loadingRights, navigate]);

  if (inProgress !== 'none' || loadingRights || (isAuthenticated && isRestricted && restricted )) {
    return <>Loading...</>; // Show loading while rights are being determined
  }
  return isAuthenticated ? <Outlet /> : <AuthLogin3 />;
}
